module.exports = __webpack_public_path__ + "images/directory/icons/customIcon.95256ec9b05953f00cab.png";